export const BRAND_CMP = 'CMP';
export const BRAND_CCS = 'CCS';
export const BRAND_CMP_TEXT = "Century Complete";
export const BRAND_CCS_TEXT = "Century Communities";
export var NodeTypes;
(function (NodeTypes) {
    NodeTypes[NodeTypes["Metro"] = 0] = "Metro";
    NodeTypes[NodeTypes["MasterPlanCommunity"] = 1] = "MasterPlanCommunity";
    NodeTypes[NodeTypes["CombinedCommunity"] = 2] = "CombinedCommunity";
    NodeTypes[NodeTypes["Community"] = 3] = "Community";
})(NodeTypes || (NodeTypes = {}));
